import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GuidService {
  private static readonly crypto = window.crypto || null;

  public static getEmpty(): string {
    return '00000000-0000-0000-0000-000000000000';
  }

  public static getGuid(): string {
    return this.hasCrypto() ? this.cryptoGuid() : this.randomGuid();
  }

  private static hasCrypto(): boolean {
    return (
      this.crypto !== undefined &&
      this.crypto !== null &&
      typeof crypto.getRandomValues !== 'undefined'
    );
  }

  private static cryptoGuid(): string {
    const buffer = new window.Uint16Array(8);

    crypto.getRandomValues(buffer);

    return [
      this.s4(buffer[0]) + this.s4(buffer[1]),
      this.s4(buffer[2]),
      this.s4(buffer[3]),
      this.s4(buffer[4]),
      this.s4(buffer[5]) + this.s4(buffer[6]) + this.s4(buffer[7]),
    ].join('-');
  }

  private static randomGuid(): string {
    let currentDateMilliseconds = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (currentChar) {
        const randomChar =
          (currentDateMilliseconds + Math.random() * 16) % 16 | 0;
        currentDateMilliseconds = Math.floor(currentDateMilliseconds / 16);
        return (
          currentChar === 'x' ? randomChar : (randomChar & 0x7) | 0x8
        ).toString(16);
      }
    );
  }

  private static s4(number: number): string {
    const hexadecimalResult = number.toString(16);
    return this.padLeft(hexadecimalResult, 4, '0');
  }

  private static padLeft(
    paddingString: string,
    width: number,
    replacementChar: string
  ): string {
    return paddingString.length >= width
      ? paddingString
      : this.padLeft(
          replacementChar + paddingString,
          width,
          replacementChar || ' '
        );
  }
}
